import { render, staticRenderFns } from "./ItemListMyItemHistoryLayout.vue?vue&type=template&id=533e5aca&scoped=true"
import script from "./ItemListMyItemHistoryLayout.vue?vue&type=script&lang=js"
export * from "./ItemListMyItemHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e5aca",
  null
  
)

export default component.exports